import { render, staticRenderFns } from "./Tab2.vue?vue&type=template&id=ac9d3816&"
import script from "./Tab2.vue?vue&type=script&lang=js&"
export * from "./Tab2.vue?vue&type=script&lang=js&"
import style0 from "./Tab2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports